import React from 'react';
import { useSelector } from 'react-redux';

import UserContainer from './UserContainer';
import HelpContainer from './HelpContainer';

import { DropdownProvider } from '../../../hooks';

import { AppState } from '../../../store';

import logo from '../../../assets/images/logo-círculo.svg';

import * as Styles from './MenuStyles';

const Menu: React.FC = () => {
  const { current_drugstore, user } = useSelector(({ permissions }: AppState) => permissions);

  return (
    <Styles.Wrapper>
      <Styles.Menu>
        <Styles.Item>
          <Styles.Link to="/">
            <Styles.Image src={logo} alt="Memed logo" />
            <strong>Memed Farmácia</strong>
            <small>Beta</small>
          </Styles.Link>
        </Styles.Item>

        <Styles.Item>
          <DropdownProvider>
            <HelpContainer />
            <UserContainer user={user?.name} drugStore={String(current_drugstore?.chain?.name)} />
          </DropdownProvider>
        </Styles.Item>
      </Styles.Menu>
    </Styles.Wrapper>
  );
};

export default Menu;
